module.exports = __webpack_public_path__ + "img/exhibition5.f4c02087.png";